import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { 
  createComponentConfig, 
  createComponentItem,
  COMPONENT_TYPES,
  PROMPT_STRATEGIES,
  TOOL_IDS
} from '../../AiToolTemplate/config/componentConfig';

const LogoGeneration = () => {
  const { t } = useI18n();

  // 创建Logo生成的配置
  const logoConfig = createComponentConfig({
    components: [
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.aspectRatio'),
        required: true,
        defaultValue: 'Auto',
        order: 2
      }),
      createComponentItem({
        type: COMPONENT_TYPES.PROMPT_INPUT,
        id: 'logoPrompt',
        title: t('logoGeneration.promptLabel'),
        description: t('logoGeneration.promptDescription'),
        required: true,
        height: 290,
        props: {
          placeholder: t('logoGeneration.promptPlaceholder'),
          minLength: 5,
          maxLength: 2000,
          showCharCount: true,
          autoResize: true
        }
      }),
      // createComponentItem({
      //   type: COMPONENT_TYPES.IMAGE_UPLOAD,
      //   id: 'referenceImage',
      //   title: t('aiToolTemplate.imageUpload.referenceTitle'),
      //   description: t('aiToolTemplate.imageUpload.referenceDescription'),
      //   required: true,
      //   promptTemplate: ', based on the reference image', // 定义在提示词中的拼接模板
      //   props: {
      //     acceptedFormats: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
      //     maxSize: 10 * 1024 * 1024, // 10MB
      //     preview: true,
      //     cropAspectRatio: null, // 允许任意比例
      //     placeholder: t('aiToolTemplate.imageUpload.referencePlaceholder')
      //   }
      // }),
      // createComponentItem({
      //   type: COMPONENT_TYPES.COLOR_PICKER,
      //   id: 'backgroundColor',
      //   title: t('aiToolTemplate.colorPicker.defaultTitle'),
      //   description: t('aiToolTemplate.colorPicker.defaultDescription'),
      //   required: false,
      //   visible: true, // 设置为true以显示颜色选择器
      //   promptTemplate: ', with background color {value}', // 定义在提示词中的拼接模板
      //   props: {
      //     presetColors: [
      //       '#ffffff', '#f8f9fa', '#e9ecef', '#dee2e6',
      //       '#000000', '#212529', '#343a40', '#495057',
      //       '#007bff', '#0056b3', '#6610f2', '#6f42c1',
      //       '#e83e8c', '#dc3545', '#fd7e14', '#ffc107',
      //       '#28a745', '#20c997', '#17a2b8', '#6c757d'
      //     ],
      //     allowCustom: true,
      //     showPreview: true,
      //     format: 'hex',
      //     allowClear: true,
      //     placeholder: '选择logo背景颜色（可选）'
      //   }
      // })
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.logoPrompt;
      }
    },
    additionalParams: {
      model: 'nano',
      width: 1024,
      height: 1024,
      style: 'logo'
    }
  });

  return (
    <AiToolTemplateV2
      toolName={t('logoGeneration.toolName')}
      toolIcon="🎨"
      toolDescription={t('logoGeneration.toolDescription')}
      config={logoConfig}
      gradientColors={['#FF6B6B', '#4ECDC4']}
      toolId={TOOL_IDS.LOGO_GENERATION}
    />
  );
};

export default LogoGeneration;
